import { Injectable } from '@angular/core';

import { ApiService } from '@dav-core/services/api.service';
import { ClaimService } from '@dav-core/services/claim.service';
import { ClaimsResponse } from '@dav-model/api/response/claims.response';
import { UserResponse } from '@dav-model/login/response/user.response.model';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators';

import * as ClaimsActions from './claims.actions';
import * as fromRoot from '../reducers';

@Injectable()
export class ClaimsEffects {
  constructor(private actions$: Actions, private apiService: ApiService, private store: Store<fromRoot.State>) {
  }

  getContracts$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(ClaimsActions.GET_CLAIMS),
    withLatestFrom(
      this.store.select(state => state.userState.user)
    ),
    mergeMap(([action, user]:
                [ClaimsActions.GetClaimsAction, UserResponse]) => {

        const allDealers = JSON.parse(JSON.stringify(user.allDealers));

        if (allDealers && allDealers.length === 1) {
          allDealers[0].cmsDealerNumber = user.cmsDealerNumber;
        }

        const request = {
          dealerId: user.cmsDealerNumber,
          allDealers: allDealers,
          searchCriteria: {
            vinCode: action.payload.vin,
            claimNumber: action.payload.claimNumber,
            claimsStatus: '',
            endDate: '',
            repairOrderNo: '',
            startDate: ''
          }
        };

        return this.apiService.getClaims(request).pipe(
          // If successful, dispatch success action with result
          map((response: ClaimsResponse) => {
            const historyFilters = ClaimService.fetchClaimFilters(response.claimStatusInformations);

            return {
              type: ClaimsActions.GET_CLAIMS_SUCCESS,
              payload: { claims: response.claimStatusInformations, filters: historyFilters }
            };
          }),
          // If request fails, dispatch failed action
          catchError((error) => {
            return of({
              type: ClaimsActions.CLAIMS_FAILURE,
              payload: error
            });
          })
        );
      }
    )
  ));
}
